// Sticky Slideshow Animation - Fixed only until scrolling text section
(function() {
  'use strict';
  
  // Only target the first slideshow section
  const slideshow = document.querySelector('.shopify-section--slideshow:first-of-type');
  
  if (!slideshow) return;
  
  // Check if slideshow is actually the first section on the page
  const firstSection = document.querySelector('main .shopify-section:first-child');
  if (firstSection !== slideshow) {
    return;
  }
  
  // Only apply on desktop
  if (window.innerWidth < 700) {
    return;
  }
  
  const content = slideshow.querySelector('.content-over-media > div[class*="surface"]');
  
  // Find the scrolling text section (the section right after slideshow)
  let scrollingTextSection = slideshow.nextElementSibling;
  
  // If there's no next section, find it by class
  if (!scrollingTextSection) {
    scrollingTextSection = document.querySelector('.shopify-section--scrolling-text');
  }
  
  // Fallback: get the 2nd section (slideshow is 1st, scrolling text is 2nd)
  if (!scrollingTextSection) {
    const allSections = document.querySelectorAll('main > .shopify-section');
    if (allSections.length >= 2) {
      scrollingTextSection = allSections[1]; // Index 1 = 2nd section
    }
  }
  
  if (!scrollingTextSection) {
    console.warn('Scrolling text section not found');
    return;
  }
  
  let ticking = false;
  let isUnsticky = false;
  
  // Delay before animation starts (in pixels of scroll)
  const ANIMATION_START_DELAY = 300; // Start animation after scrolling 300px
  
  function updateSlideshowState() {
    const scrollTop = window.scrollY;
    const slideshowHeight = slideshow.offsetHeight;
    
    // Get scrolling text section bottom position
    const scrollingTextBottom = scrollingTextSection.offsetTop + scrollingTextSection.offsetHeight;
    
    // Check if user has scrolled past scrolling text section
    if (scrollTop > scrollingTextBottom) {
      // Deactivate sticky effect
      if (!isUnsticky) {
        slideshow.classList.add('slideshow-unsticky');
        isUnsticky = true;
      }
    } else {
      // Keep sticky effect active
      if (isUnsticky) {
        slideshow.classList.remove('slideshow-unsticky');
        isUnsticky = false;
      }
      
      // Fade out slideshow content as user scrolls - but only after delay
      if (content && scrollTop > ANIMATION_START_DELAY) {
        // Adjust scroll progress to account for delay
        const adjustedScroll = scrollTop - ANIMATION_START_DELAY;
        const scrollProgress = Math.min(adjustedScroll / (slideshowHeight - ANIMATION_START_DELAY), 1);
        const opacity = 1 - (scrollProgress * 1.5);
        const translateY = scrollProgress * 30;
        
        content.style.opacity = Math.max(0, opacity);
        content.style.transform = `translateY(-${translateY}px)`;
        content.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
      } else if (content) {
        // Keep content fully visible until delay threshold
        content.style.opacity = 1;
        content.style.transform = 'translateY(0)';
      }
    }
    
    ticking = false;
  }
  
  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(updateSlideshowState);
      ticking = true;
    }
  }
  
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('load', updateSlideshowState);
  
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      if (window.innerWidth >= 700 && !ticking) {
        window.requestAnimationFrame(updateSlideshowState);
        ticking = true;
      }
    }, 150);
  });
  
  // Initial check
  updateSlideshowState();
  
  // Log for debugging
  console.log('Slideshow sticky animation initialized');
  console.log('Will stop at scrolling text section:', scrollingTextSection);
  console.log('Animation starts after:', ANIMATION_START_DELAY, 'px of scroll');
  
})();